import React from 'react';

import BrandIcon from '../cart-error-brand-logo';
import CartErrorHeading from '../cart-error-heading';

import { Heading } from './styled';

interface ICartHeading {
  modalHeading?: string;
}

const HeadingContainer = ({ modalHeading }: ICartHeading = {}) => (
  <Heading>
    <BrandIcon />
    <CartErrorHeading>{modalHeading}</CartErrorHeading>
  </Heading>
);

export default HeadingContainer;
